import { ButtonBase } from '@material-ui/core';
import styled, { css } from 'styled-components';

import type { IKakarikoButtonStyleProps } from './types';

const styles: { [key: string]: Array<Array<string | number>> } = {
  full: [['width', '100%']],
  large: [
    ['margin', 0],
    ['width', '240px'],
  ],
  medium: [
    ['font-size', '13px'],
    ['height', '34px'],
    ['line-height', '13px'],
    ['margin', 0],
    ['width', '140px'],
  ],
  small: [
    ['border-radius', '2px'],
    ['font-size', '13px'],
    ['height', '35px'],
    ['line-height', '16px'],
    ['padding', '0'],
    ['width', '55px'],
  ],
};

/* eslint-disable @typescript-eslint/indent */
export const StyledButton = styled(ButtonBase)<IKakarikoButtonStyleProps>`
  ${(props: IKakarikoButtonStyleProps & { theme: any }) => {
    let { $buttonTheme, $buttonSize, theme } = props;
    $buttonSize = $buttonSize || 'medium';

    return css`
      &.MuiButtonBase-root {
        background-color: ${theme[`${$buttonTheme}Base`]};
        background-color: var(--${$buttonTheme}-base);
        border-radius: 0;
        box-shadow: var(--low-shadow);
        color: #fff;
        color: var(--white-full);
        cursor: pointer;
        display: inline-block;
        font-size: 16px;
        font-weight: 600;
        height: 40px;
        margin: 0;
        padding: 0 10px;
        ${styles[$buttonSize]?.map(([style, rule]: Array<string | number>) => {
          return css`
            ${style}: ${rule};
          `;
        })}

        &:hover {
          background-color: ${theme[`${$buttonTheme}Dark`]};
          background-color: var(--${$buttonTheme}-dark);
        }

        &.outline {
          background-color: #fff;
          background-color: var(--white-full);
          border: 2px solid ${theme[`${$buttonTheme}Base`]};
          border: 2px solid var(--${$buttonTheme}-base);
          color: ${theme[`${$buttonTheme}Base`]};
          color: var(--${$buttonTheme}-base);

          &:hover {
            border-color: ${theme[`${$buttonTheme}Dark`]};
            border-color: var(--${$buttonTheme}-dark);
            color: ${theme[`${$buttonTheme}Dark`]};
            color: var(--${$buttonTheme}-dark);
          }
        }

        &.link {
          background-color: ${theme.white};
          background-color: var(--white-full);
          box-shadow: none;
          color: ${theme[`${$buttonTheme}Base`]};
          color: var(--${$buttonTheme}-base);
          text-decoration: underline;

          &:hover {
            color: ${theme[`${$buttonTheme}Dark`]};
            color: var(--${$buttonTheme}-dark);
          }
        }

        &:disabled {
          background-color: ${theme.defaultLight};
          background-color: var(--default-light);
          border: none;
          box-shadow: none;
          color: #fff;
          color: var(--white-full);

          &.outline {
            background-color: #fff;
            background-color: var(--white-full);
            border: 2px solid ${theme.defaultLight};
            border: 2px solid var(--default-light);
            color: ${theme.defaultLight};
            color: var(--default-light);
          }

          &.link {
            background-color: transparent;
            border: none;
            color: ${theme.defaultBase};
            color: var(--default-base);
            text-decoration: line-through;
          }
        }
      }
    `;
  }}
`;
/* eslint-enable @typescript-eslint/indent */
